import { css, FlattenSimpleInterpolation } from "styled-components";

export const breakpoints = {
  mobile: "320px",
  tablet: "768px",
  desktop: "1024px",
  wide: "1200px",
  ultraWide: "1440px",
};

// Helper function para media queries con tipos correctos
const createMediaQuery =
  (minWidth: string) =>
  (strings: TemplateStringsArray, ...args: any[]): FlattenSimpleInterpolation =>
    css`
      @media (min-width: ${minWidth}) {
        ${css(strings, ...args)}
      }
    `;

export const media = {
  mobile: createMediaQuery(breakpoints.mobile),
  tablet: createMediaQuery(breakpoints.tablet),
  desktop: createMediaQuery(breakpoints.desktop),
  wide: createMediaQuery(breakpoints.wide),
  ultraWide: createMediaQuery(breakpoints.ultraWide),
};

// Utilidades para contenedores responsivos
export const container = {
  mobile: css`
    width: 100%;
    padding: 0 16px;
    margin: 0 auto;
  `,
  tablet: css`
    max-width: 720px;
    padding: 0 24px;
    margin: 0 auto;
  `,
  desktop: css`
    max-width: 960px;
    padding: 0 32px;
    margin: 0 auto;
  `,
  wide: css`
    max-width: 1200px;
    padding: 0 40px;
    margin: 0 auto;
  `,
  ultraWide: css`
    max-width: 1400px;
    padding: 0 48px;
    margin: 0 auto;
  `,
};

// Utilidades para grid responsivo mejorado
export const grid = {
  mobile: css`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
  `,
  tablet: css`
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  `,
  desktop: css`
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
  `,
  wide: css`
    grid-template-columns: repeat(4, 1fr);
    gap: 32px;
  `,
  ultraWide: css`
    grid-template-columns: repeat(5, 1fr);
    gap: 40px;
  `,
};

// Utilidades para flexbox responsivo
export const flex = {
  mobile: css`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,
  tablet: css`
    flex-direction: row;
    gap: 24px;
  `,
  desktop: css`
    gap: 32px;
  `,
  wide: css`
    gap: 40px;
  `,
};

// Utilidades para espaciado responsivo
export const spacing = {
  mobile: {
    section: "32px",
    component: "16px",
    element: "8px",
  },
  tablet: {
    section: "48px",
    component: "24px",
    element: "12px",
  },
  desktop: {
    section: "64px",
    component: "32px",
    element: "16px",
  },
  wide: {
    section: "80px",
    component: "40px",
    element: "20px",
  },
  ultraWide: {
    section: "96px",
    component: "48px",
    element: "24px",
  },
};
